var site = site || {};
site.Videos = (() => {
    // Functions
    let userPaused = false;
    const ytVideos = () => {
        const videos = document.querySelectorAll('.js-yt-video[src]');

        videos.forEach(function(el){
            new YT.Player(el.id, {
                playerVars: {
                    'modestBranding': 1,
                    'autoplay': 1,
                    'rel': 0,
                    'showinfo': 0,
                    'autohide': 1
                },
                events: {
                    'onReady': onPlayerReady,
                    'onStateChange': onPlayerStateChange
                }
            });
        })
    }

    const ytLazyVideos = () => {
        const deferredIframes = document.querySelectorAll('.js-yt-video[data-src]');

        deferredIframes.forEach(function(iframe) {
            const videoContainer = iframe.parentElement.parentElement;
            const videoTrigger = videoContainer.previousElementSibling;
            if (!videoTrigger) return;

            const keyboardTrigger = videoTrigger.querySelector('.js-video-kb-trigger');

            let player = null;

            const activateVideo = function() {
                if (iframe.src) {
                    if (player) {
                        videoTrigger.classList.add('is-hidden');
                        videoContainer.classList.add('z-index-4');
                        player.playVideo();
                    }
                    return;
                }
                iframe.src = iframe.dataset.src;

                new YT.Player(iframe.id, {
                    playerVars: {
                        'modestBranding': 1,
                        'autoplay': 1,
                        'rel': 0,
                        'showinfo': 0,
                        'autohide': 1
                    },
                    events: {
                        'onReady': function(event) {
                            player = event.target;
                            videoTrigger.classList.add('is-hidden');
                            videoContainer.classList.add('z-index-4');
                            event.target.playVideo();
                        },
                        'onStateChange': onPlayerStateChange
                    }
                });
            };

            videoTrigger.addEventListener('click', activateVideo);

            if (keyboardTrigger) {
                keyboardTrigger.addEventListener('keypress', function(e) {
                    if (e.key === 'Enter') activateVideo();
                });
            }
        });
    }

    const onPlayerReady = function(event){
        const videoTrigger = event.target.g.parentElement.parentElement.previousElementSibling;
        const videoKeyboardTrigger = videoTrigger.querySelector('.js-video-kb-trigger');

        videoTrigger.addEventListener('click', function(){
            this.classList.add('is-hidden');
            this.nextElementSibling.classList.add('z-index-4');
            event.target.playVideo();
        })

        videoKeyboardTrigger.addEventListener('keypress', function(e){
            if (e.key === 'Enter') {
                this.parentElement.classList.add('is-hidden');
                this.parentElement.nextElementSibling.classList.add('z-index-4');
                event.target.playVideo();
            }
        })
    }

    const onPlayerStateChange = function(event) {
        const videoContainer = event.target.g.parentElement.parentElement;
        const videoTrigger = videoContainer.previousElementSibling;

        if(event.data == 2) {
            userPaused = true;
            setTimeout(() => {
                if (userPaused) {
                    videoContainer.classList.remove('z-index-4');
                    videoTrigger.classList.remove('is-hidden');
                }
            }, 300);
        }
    
        if (event.data == 1 || event.data == 3) {
            videoContainer.classList.add('z-index-4');
            videoTrigger.classList.add('is-hidden');
            userPaused = false;
        }
    }

    const ytLazyWrap = () => {
        document.querySelectorAll('.js-yt-lazy-wrap').forEach(function(wrap) {
            wrap.addEventListener('click', function handleFirstClick() {
                var videoId = wrap.dataset.videoId;
                if (!videoId) return;

                wrap.removeEventListener('click', handleFirstClick);

                var posterHTML = wrap.innerHTML;

                var iframe = document.createElement('iframe');
                iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&enablejsapi=1';
                iframe.title = 'YouTube video player';
                iframe.frameBorder = '0';
                iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
                iframe.allowFullscreen = true;
                iframe.classList.add('position-absolute', 'top-0', 'start-0', 'w-100', 'h-100');

                var overlay = document.createElement('div');
                overlay.className = 'position-absolute top-0 start-0 w-100 h-100';
                overlay.style.cssText = 'z-index: 2; display: none; cursor: pointer;';
                overlay.innerHTML = posterHTML;
                var overlayImg = overlay.querySelector('img');
                if (overlayImg) overlayImg.removeAttribute('loading');

                wrap.innerHTML = '';
                wrap.appendChild(iframe);
                wrap.appendChild(overlay);

                window.addEventListener('message', function(event) {
                    if (event.source !== iframe.contentWindow) return;
                    var data;
                    try { data = JSON.parse(event.data); } catch(e) { return; }
                    if (data.event === 'onStateChange') {
                        if (data.info === 2 || data.info === 0) {
                            overlay.style.display = '';
                        } else if (data.info === 1 || data.info === 3) {
                            overlay.style.display = 'none';
                        }
                    }
                });

                overlay.addEventListener('click', function() {
                    overlay.style.display = 'none';
                    iframe.contentWindow.postMessage(JSON.stringify({event: 'command', func: 'playVideo', args: []}), '*');
                });
            });
        });
    }

    // Return
    return {
        ytVideos : ytVideos,
        ytLazyVideos : ytLazyVideos,
        ytLazyWrap : ytLazyWrap
    };
})();
